// eslint-disable-next-line import/prefer-default-export
export const BASE_PATH = process.env.REACT_APP_URL_PATH || '';
export const PAGE_EVENTS_DEFAULT = 'page';
export const PAGE_EVENTS_HOME = 'home';
export const PAGE_EVENTS_PDP = 'pdp';
export const PAGE_EVENTS_QVIEW = 'qview';
export const PAGE_EVENTS_CATEGORY = 'category';
export const PAGE_EVENTS_CART = 'cart';
export const PAGE_EVENTS_SEARCH = 'search';
export const PAGE_EVENTS_ORDER = 'order';
export const CDP_CHANNEL = 'WEB';
export const CDP_CURRENCY = 'USD';
export const CDP_LANGUAGE = 'EN';
